import React, {useEffect, useMemo, useState} from 'react';
import {useLocation, useParams} from 'react-router';
import {getLocationById} from '../../components/location/requests/location-requests';
import {getRentalAgreementURL} from '../../util/BookingUtil';
import {getErrorMessageForNonStandardAndStandardResponse} from '../../util/NetworkErrorUtil';
import {resolveAttribution} from '../../util/AttributionUtil';
import adminEquipmentTypes from '../../components/ServiceTypes';
import {withSnackbar} from "../../components/hocs/withSnackbar";
import EquipmentTypes from "../../components/EquipmentTypes";
import BookingPaymentBody from "./BookingPaymentBody";

const BookingPayment = ({account, snackbarShowMessage}) => {
  const routerLocation = useLocation();
  const defaultBookingData = routerLocation.state?.referrerData;
  const {profileId} = useParams();
  const [bookingLocation, setBookingLocation] = useState();

  const bookingStaticData = useMemo(() => ({
    monthly: defaultBookingData?.showMonth || false,
    ignoreDate: defaultBookingData?.ignoreDate,
    ...(defaultBookingData?.brokeredBooking && {
      chargeOverages: defaultBookingData.chargeOverages,
      initialChargeAlreadyPaidValue: defaultBookingData.initialChargeAlreadyPaidValue,
      recurringChargeAlreadyPaidValue: defaultBookingData.recurringChargeAlreadyPaidValue,
      customerChargedAmountPerPeriod: defaultBookingData.customerChargedAmountPerPeriod,
      partnerPayoutAmountPerPeriod: defaultBookingData.partnerPayoutAmountPerPeriod,
      overageCustomerChargeRate: defaultBookingData.overageCustomerChargeRate,
      overagePartnerPayoutRate: defaultBookingData.overagePartnerPayoutRate,
      manualPayment: defaultBookingData.manualPayment,
    }),
  }), [defaultBookingData]);
  const isBrokeredBooking = defaultBookingData?.brokeredBooking || false;
  const attributionSource = useMemo(() => resolveAttribution(defaultBookingData), [defaultBookingData]);
  const rentalAgreementURL = getRentalAgreementURL(bookingLocation?.supplierLegalAgreementFileName);

  useEffect(() => {
    if (profileId) {
      getLocationById(profileId).then((response) => {
        setBookingLocation(response.body);
      }).catch((error) => {
        snackbarShowMessage(getErrorMessageForNonStandardAndStandardResponse(error), 'error', 15000);
      });
    }
  }, [profileId, snackbarShowMessage]);

  const assetTypeList = useMemo(() => {
    if (!bookingLocation) {
      return [''];
    }
    const options = [];
    EquipmentTypes.jsonTypes.forEach((type) => {
      if (bookingLocation.equipmentTypes.indexOf(type.assetType) > -1 && options.indexOf(type.assetType) === -1) {
        options.push(type.assetType);
      }
    });
    if (isBrokeredBooking) {
      options.push(...adminEquipmentTypes.OPTIONS)
    }
    return options;
  }, [isBrokeredBooking, bookingLocation]);

  return <BookingPaymentBody
    account={account}
    snackbarShowMessage={snackbarShowMessage}
    profileId={profileId}
    bookingLocation={bookingLocation}
    defaultBookingData={defaultBookingData}
    bookingStaticData={bookingStaticData}
    rentalAgreementURL={rentalAgreementURL}
    assetTypeList={assetTypeList}
    isBrokeredBooking={isBrokeredBooking}
    attributionSource={attributionSource}
  />;
};

export default withSnackbar(BookingPayment);
